import { useNavigate } from 'react-router-dom'
import { PropsWithChildren, useLayoutEffect, useMemo } from 'react'
import { useNavigationGuard } from './useNavigationGuard'
import { useScheduleStore } from '@/store/useScheduleStore'
import { useSlotCleanup } from '@/hooks/useSlotCleanup'

export const NavigationGuard = ({ children }: PropsWithChildren) => {
  const { nextStep, pathIncludedInSteps, pathName, canAccessCurrentRoute } =
    useNavigationGuard()

  const navigate = useNavigate()
  const hasConfirmedSchedule = useScheduleStore.getState().hasConfirmedSchedule

  useSlotCleanup()

  const shouldRedirectToNextStep = useMemo(() => {
    return pathIncludedInSteps && pathName !== nextStep
  }, [nextStep, pathIncludedInSteps, pathName])

  useLayoutEffect(() => {
    const resetScheduleData = useScheduleStore.getState().reset

    if (pathName !== '/' && hasConfirmedSchedule) {
      resetScheduleData()

      navigate('/', { replace: true })
    }

    if (shouldRedirectToNextStep) {
      navigate(nextStep, { replace: true })
    }

    if (!canAccessCurrentRoute) {
      navigate(nextStep, { replace: true })
    }
  }, [
    canAccessCurrentRoute,
    shouldRedirectToNextStep,
    hasConfirmedSchedule,
    nextStep,
    pathName,
    navigate
  ])

  if (
    hasConfirmedSchedule ||
    shouldRedirectToNextStep ||
    !canAccessCurrentRoute
  ) {
    return null
  }

  return children
}
